export const requestSortMapping = {
  firm_name: "firmName",
  patient_name: "patientName",
  status: "status",
  provider_name: "providerName",
  submittedDate: "submittedDate",
  serviceDates: "serviceDates",
};
